import { HumanFilter } from "../human-filter";

export class AskedFilter extends HumanFilter{
	FieldType:string = "string";
	IsOptional:boolean = false;
	Labels:string[] = [];
	OptionalFilterIsDisabled:boolean = false;
	UseCurrentBookYear:boolean = false;

	constructor(data?:any){
		super(data);
		if (!data) return;
		this.FieldType = data.FieldType;
		this.IsOptional = data.IsOptional;
		this.Labels = data.Labels;
		this.OptionalFilterIsDisabled = data.OptionalFilterIsDisabled || false;
		this.UseCurrentBookYear = data.UseCurrentBookYear || false;
	}

	getJSON(){
		let res = {
			...super.getJSON(),
			FieldType: this.FieldType,
			IsOptional: this.IsOptional,
			Labels: this.Labels,
			UseCurrentBookYear: this.UseCurrentBookYear,
		};
		if (this.OptionalFilterIsDisabled) {
			res.Values = [];
		}
		return res;
	}

}